import { FormValue } from '@flatsy/types/Applications'
import { Options as ButtonsOptions } from '@flatsy/core/Form/ReactFormHooks/Field/Buttons/Type'
import i18n from '@flatsy/utils/translations'

export const buyingReason = (): ButtonsOptions[] => {
  return [
    {
      label: i18n.t('main_residence'),
      value: FormValue.buyingReason.PRI,
    },
    {
      label: i18n.t('rental_investment'),
      value: FormValue.buyingReason.INV,
    },
    {
      label: i18n.t('secondary_residence'),
      value: FormValue.buyingReason.SEC,
    },
  ]
}

export const selling = (): ButtonsOptions[] => {
  return [
    {
      label: i18n.t('yes'),
      value: 'true',
    },
    {
      label: i18n.t('no'),
      value: 'false',
    },
  ]
}

export const financeOrigin = (): ButtonsOptions[] => {
  return [
    {
      label: i18n.t('personal_contribution'),
      value: FormValue.financeOrigin.OWN,
    },
    {
      label: i18n.t('personal_contribution_and_bank_loan'),
      value: FormValue.financeOrigin.BNK,
    },
  ]
}
